export default defineNuxtRouteMiddleware(() => {
  const route = useRoute();
  const origin = process.server ? useRequestURL()?.origin : window.location.origin;

  if (!origin) {
    return;
  }

  // 1. Canonical Logic (Updated for Non-Trailing Slashes)
  const path =
    route.path.length > 1 && route.path.endsWith('/')
      ? route.path.slice(0, -1)
      : route.path;
  const canonicalUrl = `${origin}${path}`;

  const headLinks = [
    {
      rel: 'canonical',
      href: canonicalUrl,
      key: 'canonical',
    },
  ];

  // 2. Pagination NoIndex Logic (New)
  const headMeta = [];
  const pageQuery = route.query.page;

  // Add noindex if page query exists and is not '1'
  if (pageQuery && pageQuery !== '1') {
    headMeta.push({
      name: 'robots',
      content: 'noindex, follow',
      key: 'robots',
    });
  }

  // 3. Apply all head changes
  useHead({
    link: headLinks,
    meta: headMeta,
  });
});
